import React from 'react'

const AssetMangementRoute = ({children}) => {
  return children
}

export default AssetMangementRoute